import WaitOpFinish from "./wait-op-finish.js";

class WaitOpFinishInstant extends WaitOpFinish {
    execute(callback) {
        callback();
        return Promise.resolve();
    }
}

export default WaitOpFinishInstant;
